// DS9.1
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { Url } from '@wix/da-url';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { useIsCurrentUserDeviationAuthor } from '../../utils/hooks/useIsCurrentUserDeviationAuthor';
import DeviationMediaService from '../../utils/DeviationMediaService';
import Heading from '../../a11y/headings/Heading';
import UserIdentity from '../../User/Identity';
import SubscriberStat from '../../Stats/SubscriberStat';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import s from './TierSidebarCard.scss';
var CARD_IMAGE_WIDTH = 275;
var CARD_IMAGE_HEIGHT = 155;
var TierSidebarCard = function (_a) {
    var _b;
    var deviation = _a.deviation, className = _a.className, _c = _a.width, width = _c === void 0 ? CARD_IMAGE_WIDTH : _c, _d = _a.height, height = _d === void 0 ? CARD_IMAGE_HEIGHT : _d, showEdit = _a.showEdit;
    var t = useTranslation().t;
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    var deviationId = deviation.deviationId, author = deviation.author, title = deviation.title, textContent = deviation.textContent;
    var _e = deviation.tier || {}, dollarPrice = _e.dollarPrice, isUserSubscribed = _e.isUserSubscribed;
    var thumb = deviation.coverImage &&
        ((_b = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation.coverImage, width, height)) === null || _b === void 0 ? void 0 : _b.src);
    var description = textContent === null || textContent === void 0 ? void 0 : textContent.excerpt;
    if (!author || !dollarPrice) {
        return null;
    }
    var button;
    // TODO: bi
    if (showEdit && isOwner) {
        button = (React.createElement(GhostButton, { size: "medium", variant: "edit-purple", onClick: function () { return alert('TODO'); } }, t('common.edit')));
    }
    else if (isUserSubscribed) {
        button = (React.createElement(SolidButton, { size: "medium", variant: 'approval-green', priority: "secondary", onClick: function () { return alert('TODO'); } }, t('deviationview.tierCard.cta.subscribed')));
    }
    else {
        button = (React.createElement(GhostButton, { size: "medium", variant: "main", href: Url.deviationLink(deviationId, author.username, title) }, t('deviationview.tierCard.explore')));
    }
    return (React.createElement(Flex, { className: classnames(s['root'], className), direction: "column" },
        React.createElement(UserIdentity, { className: s['identity'], user: author, size: "small" }),
        thumb && React.createElement("img", { className: s['image'], src: thumb, alt: "" }),
        title && React.createElement(Heading, { className: s['title'] }, title),
        React.createElement(SubscriberStat, { className: s['subscribers'], deviation: deviation }),
        description && React.createElement("div", { className: s['description'] }, description),
        React.createElement("hr", { className: s['divider'] }),
        React.createElement(Flex, { alignItems: "center" },
            React.createElement(TierPriceWithBadge, { className: s['price'], price: dollarPrice }),
            button)));
};
TierSidebarCard.displayName = 'TierSidebarCard';
export default TierSidebarCard;
//# sourceMappingURL=TierSidebarCard.js.map